import React from 'react';
import { FormGroup } from 'reactstrap';

import WarnButton from '../components/WarnButton';
import { InputField, RHFField, rfRules } from '../../../../../components/Field';
import { required } from '../../../../../components/Field/validate';
import DBSchemaModal from './DBSchemaModal';

// Migrated to react-hook-form: registers the read-only `dbSchema` field on the parent
// SyncForm's `control`; the modal sets it via the parent's setValue (onDbSchemaSelect).
function DbSchemaSelect({ control, storeId, protocol, hostName, port, dbAlias, onDbSchemaSelect }) {
  const [open, setOpen] = React.useState(false);

  function toggle() {
    setOpen(!open);
  }

  function handleSelect(value) {
    toggle();
    onDbSchemaSelect(value);
  }

  return (
    <React.Fragment>
      <FormGroup className="col-sm-12 col-xs-12 col-md-9 col-lg-9" style={{ marginBottom: 'none' }}>
        <RHFField name="dbSchema" control={control} component={InputField} type="text" id="dbSchema" readOnly rules={rfRules([required])} />
      </FormGroup>
      <FormGroup className="col-sm-12 col-xs-12 col-md-3 col-lg-3" style={{ marginBottom: 'none' }}>
        <WarnButton
          id="DbSchemaBtn"
          hasWarn={!hostName || !protocol || !port || !dbAlias}
          warningText="Please fill 'Connection' fields and 'Database id' field"
          onClick={toggle}
        />
      </FormGroup>

      <DBSchemaModal
        isOpen={open}
        storeId={storeId}
        protocol={protocol}
        hostName={hostName}
        port={port}
        dbAlias={dbAlias}
        onSelect={handleSelect}
        onCancel={toggle}
      />
    </React.Fragment>
  );
}

export default DbSchemaSelect;
